// removed by extract-text-webpack-plugin
module.exports = {"lesson-rest-time-content":"lesson-rest-time-content","header":"header","btn-wrapper":"btn-wrapper","success":"success","error":"error"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/LessonEditTime/Modal.scss
// module id = VYwO
// module chunks = 0